module.exports = __webpack_public_path__ + "static/media/SteeringFpIImageOnlyViz00.7c509abf.mp4";